export const greenTheme = {
    primaryColor100: '#73EAA8',
    primaryColor200: '#78EFAD',
    primaryColor300: '#7DF4B2',
    bgColor100: '#F2F2F2',
    bgColor200: '#EEEEEE',
    bgColor300: '#EAEAEA',
    bgColor400: '#E6E6E6',
    bgColor500: '#E2E2E2',

    primaryColor: '#20D872',
    outliendBtn:'#D9D9D9',

    single_productNumber: '#20D872',
    single_order: '#fc856a',
    catalog_productNumber: '#6ae2fc',
    catalog_order: '#5661fc',

    single_review: '#20D872',
    catalog_review: '#20D872',
    plusstore_productNumber: '#20D872',
    plusstore_order: '#20D872',

    mainFont: 'NEXON Lv1 Gothic OTF',
};

export const pinkTheme = {
    bgColor100: '#F5F5F5',
    primaryColor100: '#FF84C1',
    outliendBtn:'#D9D9D9',

    single_productNumber: '#FF84C1',
    single_order: '#f7b563',
    catalog_productNumber: '#bc53fc',
    catalog_order: '#6aa5fc',

    single_review: '#FF84C1',
    catalog_review: '#FF84C1',
    plusstore_productNumber: '#FF84C1',
    plusstore_order: '#FF84C1',

    inputError: '#B3261E',

    productName:'#24608A',
    storeName:'#919191'
};

export const toktokVer2Theme = {
    bgColor100: '#F5F5F5',

    single_productNumber: '#FF92A5',
    single_order: '#FFC65E',
    catalog_productNumber: '#A48DFF',
    catalog_order: '#73C8B0',
    plusstore_productNumber: '#FF9E57',
    plusstore_order: '#61c7ff',

    single_review: '#000000',
    catalog_review: '#000000',
};

export const commonTheme = {
    naverShoppingBlue: '#5f7cef'
}


